module.exports = __webpack_public_path__ + "static/linkedin-icon-footer-8b063a44cdc8c582bb29a592f9cf6365.png";